
import React from "react";
import DataTable from "react-data-table-component";
import { adminAccessControlColumns, aclExportColumns } from "./AdminAccessControlColumns";
import { useState, useEffect } from "react";
import {
  TextField,
  Box,
  MenuItem,
  Select,
  FormControl,
  Button,
  Grid,
  IconButton,
  Modal,
} from "@mui/material";
import "../../listings/Listing.css";
import { Check, Error } from "@mui/icons-material";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import { CustomExcelExport } from "../../common/CustomExcelExport";
import ErrorModal from "../../common/ErrorModal";
import axiosInstance from "../../common/AxiosInterceptor";
import { getUsersRoles, updateUserRole } from "../../common/constants/globalconstants";
import { useSelector } from "react-redux";
import AccessControlConfirmModal from "./AccessControlConfirmModal";

const customStyle = {
    table: {
      style: {
        border: "1px solid #DEDEDE",
        borderRadius: "5px",
        justifyContent: "center",
        marginBottom: "10px",
        marginTop: "10px",
      },
    },
    header: {
      style: {
        color: "#193062",
        justifyContent:"center",
        textAlign:"center"
      },
    },
    headRow: {
      style: {
        border: "none",
        backgroundColor: "#CDD4DC",
        fontWeight: "bold",
        color: "#002d82",
        fontSize: "14px",
        whiteSpace: "unset",
        //justifyContent:"center",
        textAlign:"center"
      },
    },
  //   headCells: {
	// 	style: {
	// 		 justifyContent:"center",
  //      textAlign:"center"
	// 	},
	// },
    rows: {
      stripedStyle: {
        backgroundColor: "#F2F3F5",
        //justifyContent: "center",
      },
    },
    // cell: {
    //   style: {
    //     justifyContent:"center",
    //     textAlign: "center"
    //   }
    // },
  };

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "30%",
  padding: "20px !important",
  bgcolor: "background.paper",
  boxShadow: 24,
  maxHeight: "80%",
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  borderRadius:"10px"
};

const msgBoxStyle= {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "20%",
  padding: "20px !important",
  bgcolor: "background.paper",
  boxShadow: 24,
  maxHeight: "80%",
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  borderRadius:"10px"
};

function AdminAccessControl() {
  //const [tableKey, setTableKey] = useState(0);
  const [loading, setloading] = useState(false); 
  const [errormodalopen, seterrormodalOpen]= useState(false);
  const [success, setSuccess] = useState(false);
  const [errorFlag, setErrorFlag] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [reqFields, setReqFields] = useState({
    userType: "",
    userName: "",
    careFacility: ""
  });
  

  const [usersRoleData, setUsersRoleData] = useState([]);
  const [initialData, setInitialData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [originalRoles, setOriginalRoles] = useState({});
  const [changedRoles, setChangedRoles] = useState({});
  const [err, setErr] = useState({
    selectedRowsErr: "",
    searchFieldsErr: ""
  });
  const [isErr, setIsErr] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const storeuser = useSelector(state => state.storeuser);

    useEffect(()=> {
      getAllUsersRolesList();
    },[])


    useEffect(() =>{
      const rolesMap ={};
      if(Object.keys(originalRoles).length === 0){
      usersRoleData && usersRoleData.forEach(row => {
        rolesMap[row.userRoleId] = row.roleId;
      });
      setOriginalRoles(rolesMap);
    }
    },[usersRoleData]);

    /*const storeOriginalRoles =(data) =>{
      const rolesMap ={};
      data && data.forEach(row => {
        rolesMap[row.userRoleId] = row.roleId;
      });
      console.log(rolesMap);
      setOriginalRoles(rolesMap);
    }*/

    const getAllUsersRolesList =async()=>{
    try {
      setloading(true);
      const request = {
        userName : storeuser && storeuser.email
      }
	    const response = await axiosInstance.post(`${getUsersRoles}`, JSON.stringify(request));
        if(response.data.isSuccess){
		      setUsersRoleData(response.data.result);
          setInitialData(response.data.result);
          seterrormodalOpen(false);
        }
        else if(!response.data.isSuccess){
          seterrormodalOpen(true);
        }
        setloading(false);
    } catch (error) {
      console.log(error.message);
      seterrormodalOpen(true);
      setloading(false);
    }
  }

    const handleCheckboxChange = (userRoleId, checked) =>{
      if(checked){
        setSelectedRows((prev) =>[...prev, userRoleId]);
        // setChangedRoles(prev => {
        //    const updated = {...prev};
        //    return updated;
        //  });
        setErr({...err, selectedRowsErr: ""});
      }
      else{
        setSelectedRows(prev => prev.filter(rowId => rowId !== userRoleId));
        const original = originalRoles[userRoleId];
        setUsersRoleData(prev =>
        prev.map(row =>(row.userRoleId === userRoleId ? {...row, roleId: original} : row))
    );
        setChangedRoles(prev => {
          const updated = {...prev};
          delete updated[userRoleId];
          return updated;
        });
      }
    };

    const handleRoleChange = (userRoleId, newRoleId) => {
    setUsersRoleData(prev =>
      prev.map(row =>(row.userRoleId === userRoleId ? {...row, roleId: newRoleId} : row))
    );
      const original = originalRoles[userRoleId];
      if(original !== newRoleId){
        setChangedRoles(prev => ({...prev, [userRoleId]: newRoleId}))
      }
      else{
        setChangedRoles(prev => {
          const updated = {...prev};
          delete updated[userRoleId];//
          return updated;
        });
      }
    };

    const handleSubmit = () =>{
      if(!validate(false, true)) {
        setOpenConfirmModal(true);
      }        
    }

    const handleConfirmYes = async() =>{
      setOpenConfirmModal(false);
      setloading(true);
        const filteredUserRoles = usersRoleData
        .filter((user) => selectedRows.includes(user.userRoleId))
        .map((user) => ({ userRoleId: user.userRoleId, roleId: user.roleId }));

        const payload = {
          userRoleList: filteredUserRoles,
          updatedBy: storeuser.email || ""
        }

        try{
          const response = await axiosInstance.post(`${updateUserRole}`, JSON.stringify(payload));
            if(response.data.isSuccess){
              setOpenModal(true);
              setSuccess(true);
              setErrorFlag(false);
              getAllUsersRolesList();
              setSelectedRows([]);
              setReqFields({
                userType: "",
                userName: "",
                careFacility: ""
              });
            } 
            else if(!response.data.isSuccess && response.data.Message) {
              setErrorMsg(response.data.Message);
              setErrorFlag(true);
              setSuccess(false);              
            }
            else if(!response.data.isSuccess){
              seterrormodalOpen(true); 
              setSuccess(false);
            }
          setloading(false);
        }
        catch (error){
          console.log(error);
          seterrormodalOpen(true);
          setloading(false);        
        }    
    }

    const handleConModalClose =() =>{
      setOpenConfirmModal(false);
    }

    const handleReset = () =>{
      //setUsersRoleData(usersRoleData);
      getAllUsersRolesList();
      setChangedRoles({});
      setSelectedRows([]);
      setReqFields({
        userType:"",
        userName:"",
        careFacility:""
      })
      setErr({...err, searchFieldsErr:"", selectedRowsErr:""});
      setIsErr(false);
    }

    const handleSearch=() =>{
      if(!validate(true, false)){
        const filteredList = initialData.filter(row =>{
          const match1 = (reqFields.userType === "" || row.userType.replace(" ","").toLowerCase().includes(reqFields.userType.toLowerCase()));
          const match2 = (reqFields.userName === "" || row.userName.toLowerCase().includes(reqFields.userName.toLowerCase()));
          const match3 = (reqFields.careFacility === "" || row.careFacilityName.toLowerCase().includes(reqFields.careFacility.toLowerCase()));
          return match1 && match2 && match3 ;
      })
       
        setUsersRoleData(filteredList);
      }
    }
    

  const handleChange=(e)=>{
    const value = e.target.value;
    setReqFields({...reqFields, 
      [e.target.name]: value
    });

    if(value || reqFields.userType !== "" || reqFields.userName !== "" || reqFields.careFacility !== ""){
      setErr({...err, searchFieldsErr: ""})
    }    
  }

  const validate =(search, submit) =>{
    let isError=false;
      if(submit && (selectedRows && selectedRows.length === 0)){
        setErr({...err, selectedRowsErr: "Please Select at least one record"});
        setIsErr(true);
        isError =true;
        setOpenModal(true);
        setSuccess(false);
        setErrorFlag(false);
      }
      else if(search 
        && (reqFields.userType ==="" || reqFields.userType=== undefined || reqFields.userType === null)
        && (reqFields.userName ==="" || reqFields.userName=== undefined || reqFields.userName === null)
        && (reqFields.careFacility ==="" || reqFields.careFacility=== undefined || reqFields.careFacility === null)
      ){
        setErr({...err, searchFieldsErr: "Please provide any Search Criteria"});
        setIsErr(true); 
        isError =true;
      }
      else{
        setErr({...err, searchFieldsErr:"", selectedRowsErr:""});
        setIsErr(false);
        isError =false;
      }
    return isError;
  }

      return (
        <div>
          {loading && (
            <>
              <Backdrop
                sx={{ color: "white", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={true}
              >
                <CircularProgress sx={{ color: "white" }} />
                <span> &nbsp;&nbsp;&nbsp;&nbsp; Loading Data... </span>
              </Backdrop>
            </>
          )}
    
        <div>
        <Box
          sx={{
          position: "relative",
          alignContent:"center",
          justifyContent: "center",
          left: "1%",
          right: "2%",
          flexDirection: "column",
          width: "97%",
          //marginTop: "5px",
          marginBottom: "10px",
          alignItems: "center",
          p: "0% 1%",
          backgroundColor: "#fcfcfc",
          borderRadius: "5px",
        }}
      >
          <h2 className="header">Access Control List</h2>
           
            <div
              style={{
                display: "flex",
                flexDirection: "row",
              }}
            >  
          <Grid container>
            <Box
            sx={{height: "12px", width:"100%", color:"red", textAlign:"center"}}>
              <p>{isErr && err.searchFieldsErr}</p>
            </Box>
          <div style={{marginTop: "15px", width:"99%", marginRight:"18px"}}>              
                  <Box
                  sx={{
                    border:"1px solid #002d82",
                    position:"relative",
                    display:"inline-block",
                    barderRadius:"5px",
                    width: "100%",
                    padding:"8px",
                    //marginRight:"8px"
                  }}>
                     <Box
                      display="flex"
                      direction="row"
                      alignItems="left"
                      justifyContent="left"
                      alignContent="left"
                      columnGap="0.5rem"
                      sx={{ width:"100%", height: "50px", m: "3px 0", marginTop:"5px" }} 
                  >
                <Grid xs={3}>
                  <Box
                    display="flex"
                    sx={{
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "center",
                      alignContent: "center",
                      height: "50px",
                      fontSize: "15px"
                    }}
                  > 
                   <p style={{width: "90px", color: "black",fontWeight: "600", marginLeft:"5px"}}>
                    User Type:</p>
                 
                 <FormControl variant="outlined" fullWidth margin="normal" size='small' 
                 style={{width:"180px"}}>
                                <Select							
                                name="userType"
                                value={reqFields.userType}
                                onChange={handleChange}
                                displayEmpty
                                >
                                <MenuItem value="">
                                <em>------- Select -------</em>
                                </MenuItem>   
                                <MenuItem value="websteruser">Webster User</MenuItem>
                                <MenuItem value="clientuser">Client User</MenuItem>
                                </Select>                    
                        </FormControl>
                 </Box>
                 </Grid>
                 <Grid xs={3}>
                  <Box
                    display="flex"
                    sx={{
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "center",
                      alignContent: "center",
                      height: "50px",
                      fontSize: "15px"
                    }}
                  > 
                  
                    <p style={{width: "120px", color: "black",fontWeight: "600", marginLeft:"5px"}}>
                    User Name:</p>
                    <TextField
                    sx={{"& .MuiInputBase-input": {padding: "8.5px 14px"},"& .MuiFormControl-root":{alignContent:"center"}}}
                    placeholder="User Name"
                    type="text"
                    variant="outlined"
                    margin="normal"
                    name="userName"
                    value={reqFields.userName}
                    onChange={handleChange}
                    />
                  
                 </Box>
                 </Grid>
                 <Grid xs={3}>
                  <Box
                    display="flex"
                    sx={{
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "center",
                      alignContent: "center",
                      height: "50px",
                      fontSize: "15px"
      
                    }}
                  > 
                  <p style={{width: "120px", color: "black",fontWeight: "600", marginLeft:"5px"}}>
                            Care Facility:</p>
                           <TextField
                            sx={{"& .MuiInputBase-input": {padding: "8.5px 14px"}, "& .MuiFormControl-root":{alignContent:"center"}}}
                            placeholder="Care Facility"
                            type="text"
                            variant="outlined"
                            margin="normal"
                            name="careFacility"
                            value={reqFields.careFacility}
                            onChange={handleChange}
                    />
                  
                  </Box> 
                  </Grid>
                  <Grid xs={3}>
                  <Box
                    display="flex"
                    sx={{
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "center",
                      alignContent: "center",
                      height: "50px",
                      fontSize: "15px",
                      columnGap: "1rem"
                    }}
                  > 
                  <Button
                    variant="contained"
                    style={{ backgroundColor:"#002d82",width: "110px", height:"35px", marginLeft: "0.5rem", marginTop:"4px"}}
                    onClick={handleSearch}
                    >
                    Search
                    </Button>
            
                    <Button
                    variant="contained"
                    style={{ backgroundColor:"#002d82",width: "110px", height:"35px", marginTop:"4px"}}
                    onClick={handleReset}
                    >
                    Reset
                      </Button> 
                  
                  </Box> 
                  </Grid>
                  </Box> 
                      
                  <Box
                  component="span"
                  sx={{ 
                    position: "absolute",
                    top: "-12px",
                    left:"15px",
                    //transform:"translateX(-50%)",
                    backgroundColor: "white",
                    padding: "0 10px",
                    fontSize:"14px",
                    whiteSpace:"nowrap"
                    }}
                      >
                       Filter Criteria:   
                            
                  </Box>
                  </Box>
          </div>
          </Grid>    
          </div> 
              <DataTable
                pagination
                striped
                highlightOnHover
                customStyles={customStyle}
                columns={adminAccessControlColumns(selectedRows, handleRoleChange, handleCheckboxChange)}
                data={usersRoleData}
                title=""
                //key={tableKey} 
                defaultSortFieldId={null}
                defaultSortAsc={null}
                paginationRowsPerPageOptions={[10, 20, 30, 40]}
                paginationPerPage={10}
                paginationComponentOptions={{
                    rowsPerPageText: "Records per page",
                    rangeSeparatorText: "Out of",
              }}
            />

                      <Box
                              display="flex"
                              flexDirection="row"
                              sx={{ width: "100%", gap:"0.5rem" }}
                            >
                               {usersRoleData && usersRoleData.length>0 ? 
                               <>
                              <Box
                              sx={{ width: "50%", justifyContent: "left", textAlign:"left", float:"left"}}>
                                    <CustomExcelExport
                                    filename={`AdminAccessControlList.xlsx`}
                                    data={usersRoleData}
                                    headers={aclExportColumns}
                                    type={`align-left`}
                                    >
                                </CustomExcelExport>
                              </Box>
                              <Box
                              sx={{ width: "50%", justifyContent: "right", textAlign:"right", float:"right"}}>
                                <Button className="resident-new-btn" variant="contained" onClick={handleSubmit}>
                                    Submit
                                </Button>
                             </Box>
                             </>
                              :null}
                      </Box>
            
            </Box>
          </div>

          {openConfirmModal &&
          <AccessControlConfirmModal
          open={openConfirmModal}
          onClose={handleConModalClose}
          onConfirmYes={handleConfirmYes}
          loading={loading}
          />
          }

          <Modal open={openModal} onClose={() => setOpenModal(false)}>
                  <>
                    {isErr && err.selectedRowsErr && (
                      <Box sx={msgBoxStyle}>
                        
                        <p style={{textAlign:"center"}}>{err.selectedRowsErr}</p>
                        <Button
                          id="modal-close-btn"
                          variant="contained"
                          onClick={()=> setOpenModal(false)}
                        >
                          Close
                        </Button>
                      </Box>
                    )
                    }

                    {success && (
                      <Box sx={style}>
                        <IconButton sx={{ border: "2px solid green", boxShadow: "none" }}>
                          <Check sx={{ color: "green" }} />
                        </IconButton>
                        <p>User(s) Role updated successfully!</p>
                        <Button
                          id="modal-close-btn"
                          variant="contained"
                          onClick={()=> setOpenModal(false)}
                        >
                          Close
                        </Button>
                      </Box>
                    )}
                    {errorFlag && (
                      <Box sx={style}>
                        <IconButton sx={{ border: "2px solid red", boxShadow: "none" }}>
                          <Error sx={{ color: "red" }} />
                        </IconButton>
                        <p> {errorMsg} </p>
                        <Button
                          id="modal-close-btn"
                          variant="contained"
                          onClick={() => setOpenModal(false)}
                        >
                          Close
                        </Button>
                      </Box>
                    )}
                  </>
          </Modal>

          {errormodalopen && (
            <ErrorModal open={true} onClose={() => seterrormodalOpen(false)} />
          )}          
        </div>
      );
}

export default AdminAccessControl;
